import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { AsyncPipe } from "@angular/common";
import { MatIcon } from "@angular/material/icon";

import { Observable } from "rxjs";

import { ServiceProCookieConsentDialog } from "./service-pro-cookie-consent-dialog";
import { ServiceProCookieConsentSandbox, ServiceProCookieConsentViewModel } from "./service-pro-cookie-consent.sandbox";
import { SvgIconRegistry } from "@dffedb/util/src/lib/svg-icon-registry.service";
import { mdiCookie } from "@mdi/js";

@Component({
    selector: "service-pro-cookie-consent-button",
    templateUrl: "./service-pro-cookie-consent-button.component.html",
    styleUrls: ["./service-pro-cookie-consent-button.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, AsyncPipe]
})
export class ServiceProCookieConsentButtonComponent {
    @Input() isLoginPage: boolean = false;
    /** Vis tekst-label i stedet for kun ikon. */
    @Input() showLabel: boolean = false;
    @Input() menuItem: boolean = false;

    public vm$: Observable<ServiceProCookieConsentViewModel>;

    constructor(
        private readonly sandbox: ServiceProCookieConsentSandbox,
        private readonly cookieConsentDialog: ServiceProCookieConsentDialog,
        private readonly svgIconRegistry: SvgIconRegistry
    ) {
        this.vm$ = this.sandbox.selectViewModel();
        this.svgIconRegistry.registerIcon(mdiCookie, "dffedb-cookie-consent.cookie");
    }

    public onClick(event: Event): void {
        event.preventDefault();
        this.cookieConsentDialog.open();
    }
}
